import React from "react";
import { Div } from "glamorous";

import styles from "../../../styles";
import icons from "../../../imgs/icons";

const colours = [
  "#DE66FF",
  "#FF6687",
  "#FF8766",
  "#DFC898",
  "#FFCC66",
  "#FFF763",
  "#CCFF66",
  "#54FF87",
  "#66CCFF",
  "#6687FF",
  "#8766FF",
  "#7D7D7D",
  "#000000",
  "#FFFFFF"
];

export default ({ activeColour, setColour }) => (
  <Div marginBottom="30px">
    <Div css={styles.text.customiseOptions}>
      {colours.map((colour, index) => (
        <Div
          key={`colour_${index}`}
          onClick={() => setColour(colour)}
          css={activeColour === colour ? styles.text.customiseOptionColourSelected : styles.text.customiseOptionColour}
        >
          {activeColour === colour && <Div css={{
            ...styles.text.activeColour,
            backgroundImage: (colour === "#FFFFFF" ? `url(${icons.tickGold})` : `url(${icons.tick})`) 
          }} />}
          <Div
            style={{
              background: colour,
              border: colour === "#FFFFFF" ? "2px solid #EDEDED" : "none",
              width: "100%",
              height: "100%"
            }}
          />
        </Div>
      ))}
    </Div>
  </Div>
);



// WEBPACK FOOTER //
// ./src/components/areas/EditorText/Colour.js